export default __webpack_public_path__ + "static/media/digitalocean.7945731c.svg";